'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
const instructionsAriaMessage = exports.instructionsAriaMessage = (event, context = {}) => {
  const { isSearchable, isMulti, label } = context;
  switch (event) {
    case 'menu':
      return 'Use Up and Down to choose options, press Backspace to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.';
    case 'input':
      return `${label ? label : 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}`;
    case 'value':
      return 'Use left and right to toggle between focused values, press Enter to remove the currently focused value';
  }
};

const valueEventAriaMessage = exports.valueEventAriaMessage = (event, context) => {
  const { value } = context;
  if (!value) return;
  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return `option ${value}, deselected.`;
    case 'select-option':
      return `option ${value}, selected.`;
  }
};

const valueFocusAriaMessage = exports.valueFocusAriaMessage = ({ focusedValue, getOptionLabel, selectValue }) => `value ${getOptionLabel(focusedValue)} focused, ${selectValue.indexOf(focusedValue) + 1} of ${selectValue.length}.`;
const optionFocusAriaMessage = exports.optionFocusAriaMessage = ({ focusedOption, getOptionLabel, options }) => `option ${getOptionLabel(focusedOption)} focused, ${options.indexOf(focusedOption) + 1} of ${options.length}.`;
const resultsAriaMessage = exports.resultsAriaMessage = ({ inputValue, screenReaderMessage }) => `${screenReaderMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;